import * as React from 'react';
import { useRef } from 'react';
import { PostScheduleViewProps } from '../PostSchedule.view';
import { PostScheduleWeekView, PostScheduleWeekViewProps } from './PostScheduleWeek.view';
import { PostItemFragment } from '../../../../models/graphql';

export type PostScheduleWeekControllerProps = PostScheduleViewProps & {
  scheduleItems: PostItemFragment[];
  getPostScheduleWeekPostItems: () => Promise<void>;
};

export const PostScheduleWeekController = (props: PostScheduleWeekControllerProps): JSX.Element => {
  const leftColRef = useRef<HTMLDivElement>(null);

  const viewProps: PostScheduleWeekViewProps = {
    ...props,
    leftColRef
  };

  return <PostScheduleWeekView {...viewProps} />;
};
